// extracted by mini-css-extract-plugin
export default {"mobile":"KubSJS","root":"QwxLu3","onImage":"wdExWB"};